import axios from 'axios'

const getPortfolio = async () =>
  axios.get(`${process.env.REACT_APP_URI}/portfolio`)

export { getPortfolio }
